module.exports = __webpack_public_path__ + "img/chinesecompany32.b7733e0a.png";